import { cloneElement, ReactNode } from 'react';
import {
  Box,
  CSSObject,
  Flex,
  Spinner,
  SpinnerProps,
  Text,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export interface SpinProps {
  spinning?: boolean;
  size?: SpinnerProps['size'];
  tip?: React.ReactNode;
  delay?: number;
  wrapperClassName?: string;
  indicator?: ReactNode;
  children?: React.ReactNode;
  tipProps?: CSSObject;
  containerProps?: CSSObject;
  spinWrapperProps?: CSSObject;
  spinnerProps?: SpinnerProps;
  blurContainerProps?: CSSObject;
}

let spinIndicator: ReactNode = null;

export const Spin = (props: SpinProps) => {
  const {
    spinning,
    size = 'xl',
    tip = 'Loading...',
    delay,
    indicator,
    children,
    tipProps,
    containerProps,
    spinWrapperProps,
    spinnerProps,
    blurContainerProps,
  } = props;
  const styles = useMultiStyleConfig('Spin', props);
  return (
    <Box
      zIndex={spinning ? 99999999 : 'unset'}
      sx={{ ...styles.Container, ...containerProps }}
    >
      <Text sx={{ ...styles.Indicator, ...spinWrapperProps }}>
        {spinning && (
          <Flex sx={{ ...styles.SpinWrapper }}>
            {indicator ? (
              cloneElement(<span>{indicator}</span>, {
                className: 'spinner',
              })
            ) : spinIndicator ? (
              spinIndicator
            ) : (
              <Spinner
                size={size}
                speed={`${delay?.toString() || 0.45}s`}
                sx={{ ...styles.Spinner }}
                {...spinnerProps}
              />
            )}
            <Text sx={{ ...tipProps }}>{tip}</Text>
          </Flex>
        )}
      </Text>
      <Box sx={{ ...styles.BlurContainer, ...blurContainerProps }}>
        {children}
      </Box>
    </Box>
  );
};
Spin.setDefaultIndicator = (indicator: ReactNode) => {
  spinIndicator = indicator;
};
